import React from "react";
import { useNavigate, useRouteError } from "react-router-dom";
import ErrorPage from "./ErrorPage";

// Shown by the router when a page fails. Going home clears the error, because the
// router resets its error page whenever the location changes.
const RouteErrorPage = () => {
  const error = useRouteError();
  const navigate = useNavigate();
  return (
    <ErrorPage error={error} onGoHome={() => navigate("/", { replace: true })} />
  );
};

export default RouteErrorPage;
